var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "提交反馈",
      visible: _vm.isShowDialog,
      "show-close": false,
      modal: "",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      width: "25%"
    }
  }, [_c("div", [_vm._v("您对本平台还有那些意见？")]), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.content,
      expression: "content"
    }],
    staticClass: "textarea",
    attrs: {
      name: "note",
      id: "",
      cols: "45",
      rows: "4",
      wrap: "virtual"
    },
    domProps: {
      value: _vm.content
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) return;
        _vm.content = $event.target.value;
      }
    }
  }), _c("pic-upload", {
    ref: "picUupload",
    attrs: {
      fullUrl: true,
      complaints: true
    },
    model: {
      value: _vm.pic,
      callback: function ($$v) {
        _vm.pic = $$v;
      },
      expression: "pic"
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    staticClass: "plain btnsSpacing",
    attrs: {
      plain: ""
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), _c("el-button", {
    staticClass: "primary btnsSpacing",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.uploadFile
    }
  }, [_vm._v("确定")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };